import { render } from "./RegisteredView.vue?vue&type=template&id=5dc9eb6a&scoped=true"
import script from "./RegisteredView.vue?vue&type=script&lang=js"
export * from "./RegisteredView.vue?vue&type=script&lang=js"

import "./RegisteredView.vue?vue&type=style&index=0&id=5dc9eb6a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc9eb6a"]])

export default __exports__